// src/views/reservas/ReservasList.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import reservasService from "../../services/reservasService";
import areasConunsService from "../../services/areasConunsService";
import condominiosService from "../../services/condominiosService";
import { useAuth } from "../../contexts/AuthContext";
import condominosService  from "../../services/condominosService";
import vinculosService     from "../../services/vinculosService";
import unidadesService from "../../services/unidadesService";
import Banner from "../../components/ui/Banner";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtMoeda = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const fmtDt    = dt => { if(!dt) return "-"; try{ return new Date((String(dt||"").split("T")[0])+"T12:00:00").toLocaleDateString("pt-BR"); }catch{return dt;} };

const STATUS_STYLE = {
  Pendente:   {background:"var(--bg-warning-soft)",color:"#854D0E"},
  Confirmada: {background:"var(--bg-highlight)",color:"#1E40AF"},
  Paga:       {background:"var(--bg-success-soft)",color:"#166534"},
  Ativa:      {background:"var(--bg-success-soft)",color:"#166534"},
  Realizada:  {background:"var(--bg-page)",color:"var(--gray-500)"},
  Cancelada:  {background:"var(--bg-danger-soft)",color:"#991B1B"},
};

const MESES = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

export default function ReservasList() {
  const { condominioAtivo, isAdmin, isGerente } = useAuth();
  const { podeEditar } = useAuth();
  const canEdit = podeEditar("reservas");
  const [aba, setAba]               = useState("lista");
  const [condominios, setCondominios] = useState([]);
  const [idCondo, setIdCondo]       = useState("");
  const [areas, setAreas]           = useState([]);
  const [condominos, setCondominos] = useState([]);
  const [unidades, setUnidades]       = useState([]);
  const [unidadesFilt, setUnidadesFilt] = useState([]);
  const [vincMap, setVincMap]           = useState({}); // {idCondomino: [idUnidade,...]}
  const [reservas, setReservas]     = useState([]);
  const [loading, setLoading]       = useState(false);
  const [pagination, setPagination] = useState({total:0,totalPages:1});
  const [filtros, setFiltros]       = useState({idArea:"",status:"",idUnidade:"",idCondomino:"",dtInicio:"",dtFim:"",page:1});

  // Calendário
  const hoje = new Date();
  const [calMes, setCalMes]         = useState(`${hoje.getFullYear()}-${String(hoje.getMonth()+1).padStart(2,"0")}`);
  const [calArea, setCalArea]       = useState("");
  const [calData, setCalData]       = useState(null);
  const [calLoading, setCalLoading] = useState(false);

  // Nova reserva
  const [showForm, setShowForm]     = useState(false);
  const [form, setForm]             = useState({idArea:"",idUnidade:"",idCondomino:"",dtReserva:"",hrInicio:"",hrFim:"",solicitadoPor:"Administrador",nmSolicitante:"",tpCobrancaReserva:"Mensal",observacao:""});
  const [disponibilidade, setDisponibilidade] = useState(null);
  const [checkingDisp, setCheckingDisp] = useState(false);
  const [saving, setSaving]         = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // Caução
  const [showCaucao, setShowCaucao] = useState(false);
  const [caucaoTarget, setCaucaoTarget] = useState(null);
  const [caucaoForm, setCaucaoForm] = useState({reter:false,motivoRetencao:"",dtDevolucao:new Date().toISOString().split("T")[0]});

  // Banner + confirmação genérica
  const [banner, setBanner] = useState(null);
  const showBanner = (tipo, msg) => { setBanner({ tipo, msg }); setTimeout(()=>setBanner(null), 7000); };
  const [confirmacao, setConfirmacao] = useState(null);

  // Modal de cancelamento (substitui prompt)
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelMotivo, setCancelMotivo] = useState("");
  const [cancelSaving, setCancelSaving] = useState(false);

  // Sync with auth context when condominioAtivo changes
  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
  }, [condominioAtivo]);

  useEffect(() => {
    condominiosService.listar({limit:100}).then(r=>{ setCondominios(r.data); }).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!idCondo) return;
    areasConunsService.listar({idCondominio:idCondo,situacao:"Ativa"}).then(r=>{ setAreas(r.data); if(r.data.length>0&&!calArea) setCalArea(String(r.data[0].id)); }).catch(()=>{});
    condominosService.listarSelect(idCondo).then(r=>setCondominos(r.data||[])).catch(()=>{});
    unidadesService.listar({idCondominio:idCondo,limit:200}).then(r=>{
      const us = r.data||[];
      setUnidades(us);
      setUnidadesFilt(us);
      // Monta mapa condômino → unidades via unidade_vinculos
      // Busca todos os vinculos do condomínio
      import("../../services/vinculosService").then(m => {
        Promise.all(us.map(u => m.default.listar(u.id).catch(()=>({data:[]}))))
          .then(results => {
            const map = {};
            results.forEach((r2, i) => {
              (r2.data||[]).forEach(v => {
                if (v.idCondomino && v.ativo) {
                  const key = String(v.idCondomino);
                  if (!map[key]) map[key] = [];
                  if (!map[key].includes(us[i].id)) map[key].push(us[i].id);
                }
              });
            });
            setVincMap(map);
          });
      });
    }).catch(()=>{});
  }, [idCondo]);

  const carregar = useCallback(async () => {
    if (!idCondo) return;
    setLoading(true);
    try { const r=await reservasService.listar({idCondominio:idCondo,...filtros,limit:15}); setReservas(r.data); setPagination(r.pagination); }
    catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [idCondo, filtros]);

  useEffect(() => { if(aba==="lista") carregar(); }, [carregar, aba]);

  const setF = (f,v) => setFiltros(p=>({...p,[f]:v,page:1}));
  const setFrm = (f,v) => { setForm(p=>({...p,[f]:v})); setFormErrors(p=>({...p,[f]:undefined})); setDisponibilidade(null); };

  // Verifica disponibilidade ao mudar data/hora
  useEffect(() => {
    if (!form.idArea||!form.dtReserva) return;
    const timer = setTimeout(async () => {
      setCheckingDisp(true);
      const p={idArea:form.idArea, dtReserva:form.dtReserva};
      const areaObj = areas.find(a=>String(a.id)===String(form.idArea));
      if (areaObj?.tpPeriodo==="Horario"&&form.hrInicio&&form.hrFim) { p.hrInicio=form.hrInicio; p.hrFim=form.hrFim; }
      const r = await areasConunsService.verificarDisponibilidade(p).catch(()=>null);
      setDisponibilidade(r);
      setCheckingDisp(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [form.idArea, form.dtReserva, form.hrInicio, form.hrFim, areas]);

  const areaForm = areas.find(a=>String(a.id)===String(form.idArea));

  const handleSalvarReserva = async () => {
    const e={};
    if(!form.idArea) e.idArea="Selecione a área";
    if(!form.dtReserva) e.dtReserva="Data obrigatória";
    if(areaForm?.tpPeriodo==="Horario"&&(!form.hrInicio||!form.hrFim)) e.hrInicio="Horários obrigatórios";
    if(disponibilidade&&!disponibilidade.disponivel) e.dtReserva=disponibilidade.motivo;
    setFormErrors(e); if(Object.keys(e).length) return;

    setSaving(true);
    try {
      await reservasService.criar({...form, idCondominio:idCondo, tpCobrancaReserva:form.tpCobranca||"Mensal"});
      setShowForm(false); setForm({idArea:"",idUnidade:"",idCondomino:"",dtReserva:"",hrInicio:"",hrFim:"",solicitadoPor:"Administrador",nmSolicitante:"",observacao:"",tpCobranca:"Mensal"});
      showBanner("success", "Reserva criada com sucesso.");
      await carregar();
    } catch(er) { showBanner("error", er.message || "Erro ao criar reserva."); }
    finally { setSaving(false); }
  };

  const handleAcao = (id, acao) => {
    if (acao === "cancelar") {
      setCancelTarget(id);
      setCancelMotivo("");
      return;
    }
    const labels = { confirmar:"confirmar", pagar:"marcar como paga", realizar:"marcar como realizada" };
    setConfirmacao({
      titulo: `Confirmar — ${labels[acao]}`,
      mensagem: `Tem certeza que deseja ${labels[acao]} esta reserva?`,
      textoOk: "Confirmar",
      perigo: false,
      onConfirm: async () => {
        try {
          if(acao==="confirmar")      await reservasService.confirmar(id);
          else if(acao==="pagar")     await reservasService.marcarPaga(id);
          else if(acao==="realizar")  await reservasService.realizar(id);
          setConfirmacao(null);
          showBanner("success", "Operação realizada.");
          await carregar();
        } catch(e) {
          setConfirmacao(null);
          showBanner("error", e.message || "Erro ao executar ação.");
        }
      },
    });
  };

  const confirmarCancelamento = async () => {
    if (!cancelTarget) return;
    setCancelSaving(true);
    try {
      await reservasService.cancelar(cancelTarget, { motivo: cancelMotivo.trim() || null });
      setCancelTarget(null);
      setCancelMotivo("");
      showBanner("success", "Reserva cancelada.");
      await carregar();
    } catch(e) {
      showBanner("error", e.message || "Erro ao cancelar reserva.");
    } finally {
      setCancelSaving(false);
    }
  };

  const handleDevolverCaucao = async () => {
    if (caucaoForm.reter && !caucaoForm.motivoRetencao.trim()) {
      return showBanner("warning", "Informe o motivo da retenção.");
    }
    try {
      await reservasService.devolverCaucao(caucaoTarget.id, caucaoForm);
      setShowCaucao(false);
      showBanner("success", caucaoForm.reter ? "Caução retida." : "Caução devolvida.");
      await carregar();
    } catch(e) { showBanner("error", e.message || "Erro ao processar caução."); }
  };

  // ── Export CSV ──
  const exportarCSV = () => {
    if (!reservas.length) return showBanner("warning", "Nada a exportar.");
    const headers = ["Área","Data","Hr Início","Hr Fim","Condômino","Unidade","Bloco","Locação","Caução","Status","Solicitado por"];
    const rows = reservas.map(r => [
      r.nmArea || "", fmtDt(r.dtReserva), r.hrInicio || "", r.hrFim || "",
      r.nmCondomino || "", r.unidade || "", r.bloco || "",
      Number(r.vlrLocacao||0).toFixed(2).replace(".",","),
      Number(r.vlrCaucao||0).toFixed(2).replace(".",","),
      r.status || "", r.solicitadoPor || "",
    ]);
    const csv = [headers, ...rows].map(row =>
      row.map(c => `"${String(c).replace(/"/g,'""')}"`).join(";")
    ).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type:"text/csv;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href = url; a.download = `reservas_${new Date().toISOString().slice(0,10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  // Calendário
  const carregarCalendario = useCallback(async () => {
    if(!calArea||!calMes) return;
    setCalLoading(true);
    try { const r=await reservasService.calendario(calArea,calMes); setCalData(r); }
    catch(e) { console.error(e); }
    finally { setCalLoading(false); }
  }, [calArea, calMes]);

  useEffect(() => { if(aba==="calendario") carregarCalendario(); }, [carregarCalendario, aba]);

  // Monta grade do calendário
  const buildCalGrid = () => {
    if(!calData) return [];
    const [ano,mes] = calMes.split("-").map(Number);
    const primeiroDia = new Date(ano,mes-1,1).getDay();
    const diasNoMes = new Date(ano,mes,0).getDate();
    const cells = [];
    for(let i=0;i<primeiroDia;i++) cells.push(null);
    for(let d=1;d<=diasNoMes;d++) {
      const dtStr = `${ano}-${String(mes).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
      const resNoDia = calData.reservas?.filter(r=>r.dtReserva?.substring(0,10)===dtStr)||[];
      const bloqNoDia = calData.bloqueios?.filter(b=>b.dtInicio<=dtStr&&b.dtFim>=dtStr)||[];
      cells.push({dia:d, dtStr, reservas:resNoDia, bloqueios:bloqNoDia});
    }
    return cells;
  };

  const cells = buildCalGrid();
  const mesAno = calMes ? `${MESES[parseInt(calMes.split("-")[1])-1]}/${calMes.split("-")[0]}` : "";
  const prevMes = () => { const [a,m]=calMes.split("-").map(Number); const d=new Date(a,m-2,1); setCalMes(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`); };
  const nextMes = () => { const [a,m]=calMes.split("-").map(Number); const d=new Date(a,m,1); setCalMes(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`); };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-calendar-check me-2" style={{color:"var(--primary)",fontSize:22}}/>Reservas</h1>
          <p className="page-subtitle">Gestão de reservas de áreas comuns</p>
        </div>
        <div className="d-flex gap-2 align-items-center flex-wrap">
          <button className="btn btn-outline-secondary" onClick={exportarCSV} disabled={!reservas.length}>
            <i className="bi bi-download me-1"/>Exportar CSV
          </button>
          <button className="btn btn-primary" onClick={()=>setShowForm(p=>!p)} disabled={!idCondo}>
            <i className="bi bi-plus-lg"/> Nova Reserva
          </button>
        </div>
      </div>

      {banner && (
        <Banner tipo={banner.tipo} onClose={()=>setBanner(null)}>
          {banner.msg}
        </Banner>
      )}

      {/* Form nova reserva */}
      {showForm&&(
        <div className="card mb-3">
          <div style={{padding:"14px 16px",borderBottom:"1px solid var(--gray-100)",background:"var(--primary)",borderRadius:"12px 12px 0 0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{color:"#fff",fontWeight:600,fontSize:14}}><i className="bi bi-calendar-plus me-2"/>Nova Reserva</span>
            <button className="btn-close btn-close-white btn-sm" onClick={()=>setShowForm(false)}/>
          </div>
          <div style={{padding:16}}>
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label">Área <span className="required-mark">*</span></label>
                <select className={`form-select ${formErrors.idArea?"is-invalid":""}`} value={form.idArea} onChange={e=>setFrm("idArea",e.target.value)}>
                  <option value="">— Selecione —</option>
                  {areas.map(a=><option key={a.id} value={a.id}>{a.nmArea}</option>)}
                </select>
                {formErrors.idArea&&<div className="invalid-feedback">{formErrors.idArea}</div>}
              </div>
              <div className="col-md-2">
                <label className="form-label">Data <span className="required-mark">*</span></label>
                <input type="date" className={`form-control ${formErrors.dtReserva?"is-invalid":""}`} value={form.dtReserva} onChange={e=>setFrm("dtReserva",e.target.value)}/>
                {formErrors.dtReserva&&<div className="invalid-feedback">{formErrors.dtReserva}</div>}
              </div>
              {areaForm?.tpPeriodo==="Horario"&&<>
                <div className="col-md-2"><label className="form-label">Hr Início</label><input type="time" className={`form-control ${formErrors.hrInicio?"is-invalid":""}`} value={form.hrInicio} onChange={e=>setFrm("hrInicio",e.target.value)}/>{formErrors.hrInicio&&<div className="invalid-feedback">{formErrors.hrInicio}</div>}</div>
                <div className="col-md-2"><label className="form-label">Hr Fim</label><input type="time" className="form-control" value={form.hrFim} onChange={e=>setFrm("hrFim",e.target.value)}/></div>
              </>}
              <div className="col-md-3">
                <label className="form-label">Condômino</label>
                <select className="form-select" value={form.idCondomino} onChange={e=>{
                      const idCond = e.target.value;
                      setFrm("idCondomino", idCond);
                      setFrm("idUnidade", "");
                      if (idCond) {
                        const ids = vincMap[String(idCond)] || [];
                        const uvs = ids.length > 0
                          ? unidades.filter(u => ids.includes(u.id))
                          : unidades; // fallback: mostra tudo se vincMap não carregou
                        setUnidadesFilt(uvs);
                        if (uvs.length === 1) setFrm("idUnidade", String(uvs[0].id));
                      } else {
                        setUnidadesFilt(unidades);
                      }
                    }}>
                  <option value="">— Sem vínculo —</option>
                  {condominos.map(c=><option key={c.id} value={c.id}>{c.nmCompleto}</option>)}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Unidade</label>
                <select className="form-select" value={form.idUnidade} onChange={e=>{
                      const idU = e.target.value;
                      setFrm("idUnidade", idU);
                      // Auto-fill condômino from unit vinculos
                      if (idU && !form.idCondomino) {
                        import("../../services/vinculosService").then(m =>
                          m.default.listar({idUnidade:idU}).then(r => {
                            const v = (r.data||[]).find(x=>x.ativo);
                            if (v?.idCondomino) setFrm("idCondomino", String(v.idCondomino));
                          }).catch(()=>{})
                        );
                      }
                    }}>
                  <option value="">— Sem vínculo —</option>
                  {unidadesFilt.map(u=><option key={u.id} value={u.id}>{u.bloco?`Bl ${u.bloco} — `:""}Un {u.unidade}</option>)}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Solicitado por</label>
                <select className="form-select" value={form.solicitadoPor} onChange={e=>setFrm("solicitadoPor",e.target.value)}>
                  <option value="Administrador">Administrador</option>
                  <option value="Condomino">Condômino</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Nome do solicitante</label>
                <input className="form-control" value={form.nmSolicitante} onChange={e=>setFrm("nmSolicitante",e.target.value)} placeholder="Opcional"/>
              </div>
              {areaForm?.vlrLocacao>0 && (
                <div className="col-md-3">
                  <label className="form-label">Tipo de Cobrança</label>
                  <select className="form-select" value={form.tpCobrancaReserva}
                    onChange={e=>setFrm("tpCobrancaReserva",e.target.value)}>
                    <option value="Mensal">Incluir no boleto mensal</option>
                    <option value="Avulso">Boleto avulso</option>
                    <option value="Isento">Isento / Sem cobrança</option>
                  </select>
                </div>
              )}

              {/* Disponibilidade */}
              {(form.idArea&&form.dtReserva)&&(
                <div className="col-12">
                  {checkingDisp
                    ? <div style={{fontSize:12.5,color:"var(--gray-500)"}}><span className="spinner-border spinner-border-sm me-2"/>Verificando disponibilidade...</div>
                    : disponibilidade
                      ? disponibilidade.disponivel
                        ? <div style={{background:"var(--bg-success-soft)",border:"1px solid #BBF7D0",borderRadius:6,padding:"8px 14px",fontSize:12.5,color:"#166534",fontWeight:600}}>
                            <i className="bi bi-check-circle me-2"/>Data disponível!
                            {areaForm&&<span style={{marginLeft:12}}>Locação: <strong>{fmtMoeda(areaForm.vlrLocacao)}</strong>{parseFloat(areaForm.vlrCaucao)>0&&<> + Caução: <strong>{fmtMoeda(areaForm.vlrCaucao)}</strong></>}</span>}
                          </div>
                        : <div style={{background:"var(--bg-danger-soft)",border:"1px solid #FCA5A5",borderRadius:6,padding:"8px 14px",fontSize:12.5,color:"#991B1B",fontWeight:600}}>
                            <i className="bi bi-x-circle me-2"/>Indisponível: {disponibilidade.motivo}
                          </div>
                      : null
                  }
                </div>
              )}

              <div className="col-12">
                <label className="form-label">Observações</label>
                <input className="form-control" value={form.observacao} onChange={e=>setFrm("observacao",e.target.value)}/>
              </div>
              <div className="col-12 d-flex justify-content-end gap-2">
                <button className="btn btn-outline-secondary" onClick={()=>setShowForm(false)}><i className="bi bi-x-circle"/> Cancelar</button>
                <button className="btn btn-primary" onClick={handleSalvarReserva} disabled={saving||checkingDisp||(disponibilidade&&!disponibilidade.disponivel)}>
                  {saving?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> Criar Reserva</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        {/* Sub-abas */}
        <div style={{borderBottom:"1px solid var(--gray-200)",padding:"0 16px",display:"flex",gap:4}}>
          {[{id:"lista",label:"Lista de Reservas",icon:"bi-list-ul"},{id:"calendario",label:"Calendário",icon:"bi-calendar3"}].map(t=>(
            <button key={t.id} className="btn border-0 d-flex align-items-center gap-1"
              style={{fontSize:13,padding:"12px 14px",borderRadius:0,borderBottom:aba===t.id?"2px solid var(--primary)":"2px solid transparent",fontWeight:aba===t.id?600:400,color:aba===t.id?"var(--primary)":"var(--gray-500)",background:"transparent"}}
              onClick={()=>setAba(t.id)}>
              <i className={`bi ${t.icon}`}/>{t.label}
            </button>
          ))}
        </div>

        {/* ── LISTA ── */}
        {aba==="lista"&&(
          <>
            <div style={{padding:"12px 16px",borderBottom:"1px solid var(--gray-100)",display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
              <select className="form-select form-select-sm" style={{width:"auto",minWidth:140}} value={filtros.idArea} onChange={e=>setF("idArea",e.target.value)}>
                <option value="">Todas as áreas</option>
                {areas.map(a=><option key={a.id} value={a.id}>{a.nmArea}</option>)}
              </select>
              <select className="form-select form-select-sm" style={{width:"auto",minWidth:140}} value={filtros.status} onChange={e=>setF("status",e.target.value)}>
                <option value="">Todos os status</option>
                {["Pendente","Confirmada","Paga","Ativa","Realizada","Cancelada"].map(s=><option key={s}>{s}</option>)}
              </select>
              <select className="form-select form-select-sm" style={{width:"auto",minWidth:160}} value={filtros.idCondomino} onChange={e=>setF("idCondomino",e.target.value)} title="Condômino">
                <option value="">Todos os condôminos</option>
                {condominos.map(c=><option key={c.id} value={c.id}>{c.nmCompleto}</option>)}
              </select>
              <select className="form-select form-select-sm" style={{width:"auto",minWidth:140}} value={filtros.idUnidade} onChange={e=>setF("idUnidade",e.target.value)} title="Unidade">
                <option value="">Todas as unidades</option>
                {unidades.map(u=><option key={u.id} value={u.id}>{u.bloco?`Bl ${u.bloco} — `:""}Un {u.unidade}</option>)}
              </select>
              <input type="date" className="form-control form-control-sm" style={{width:140}} value={filtros.dtInicio} onChange={e=>setF("dtInicio",e.target.value)} title="De"/>
              <input type="date" className="form-control form-control-sm" style={{width:140}} value={filtros.dtFim} onChange={e=>setF("dtFim",e.target.value)} title="Até"/>
              <button className="btn btn-outline-secondary btn-sm" onClick={carregar} title="Recarregar"><i className="bi bi-arrow-clockwise"/></button>
              {(filtros.idArea||filtros.status||filtros.idCondomino||filtros.idUnidade||filtros.dtInicio||filtros.dtFim) && (
                <button className="btn btn-link btn-sm p-0" style={{fontSize:12}} onClick={()=>setFiltros({idArea:"",status:"",idUnidade:"",idCondomino:"",dtInicio:"",dtFim:"",page:1})}>
                  Limpar filtros
                </button>
              )}
            </div>

            <div className="table-responsive">
              <table className="table table-custom">
                <thead><tr>
                  <th>Área</th><th>Data / Horário</th><th>Condômino</th><th>Unidade</th>
                  <th style={{textAlign:"right"}}>Locação</th><th style={{textAlign:"right"}}>Caução</th>
                  <th>Status</th><th style={{width:160}}>Ações</th>
                </tr></thead>
                <tbody>
                  {loading?<tr><td colSpan={8} className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary me-2"/></td></tr>
                  :!idCondo?<tr><td colSpan={8} className="text-center py-4" style={{color:"var(--gray-400)"}}>Selecione um condomínio</td></tr>
                  :reservas.length===0?<tr><td colSpan={8} className="text-center py-4" style={{color:"var(--gray-400)"}}><i className="bi bi-calendar-x" style={{fontSize:28,display:"block",marginBottom:8}}/>Nenhuma reserva</td></tr>
                  :reservas.map(r=>(
                    <tr key={r.id}>
                      <td><div style={{fontWeight:600,fontSize:13}}>{r.nmArea}</div></td>
                      <td>
                        <div style={{fontSize:13,fontWeight:600}}>{fmtDt(r.dtReserva)}</div>
                        {r.tpPeriodo==="Horario"&&r.hrInicio&&<div style={{fontSize:11.5,color:"var(--gray-400)"}}>{r.hrInicio?.substring(0,5)} – {r.hrFim?.substring(0,5)}</div>}
                      </td>
                      <td style={{fontSize:13}}>{r.nmCondomino||<span style={{color:"var(--gray-400)"}}>—</span>}</td>
                      <td style={{fontSize:12.5}}>{r.unidade?<span>{r.bloco?`Bl ${r.bloco} — `:""}Un {r.unidade}</span>:<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                      <td style={{textAlign:"right",fontWeight:600,fontSize:13,color:"var(--primary)"}}>{fmtMoeda(r.vlrLocacao)}</td>
                      <td style={{textAlign:"right",fontSize:13,color:parseFloat(r.vlrCaucao)>0?"#854D0E":"var(--gray-300)"}}>{parseFloat(r.vlrCaucao)>0?fmtMoeda(r.vlrCaucao):"—"}</td>
                      <td><span style={{...STATUS_STYLE[r.status],padding:"2px 9px",borderRadius:12,fontSize:11.5,fontWeight:600}}>{r.status}</span></td>
                      <td>
                        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                          {r.status==="Pendente"&&<button className="btn btn-success btn-sm" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>handleAcao(r.id,"confirmar")}><i className="bi bi-check-lg"/> Confirmar</button>}
                          {r.status==="Confirmada"&&<button className="btn btn-primary btn-sm" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>handleAcao(r.id,"pagar")}><i className="bi bi-cash"/> Paga</button>}
                          {["Paga","Ativa"].includes(r.status)&&<button className="btn btn-outline-secondary btn-sm" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>handleAcao(r.id,"realizar")}><i className="bi bi-check2-all"/> Realizada</button>}
                          {r.status==="Realizada"&&parseFloat(r.vlrCaucao)>0&&!r.caucaoDevolvida&&(
                            <button className="btn btn-warning btn-sm" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>{ setCaucaoTarget(r); setShowCaucao(true); }}>
                              <i className="bi bi-shield-check"/> Caução
                            </button>
                          )}
                          {!["Realizada","Cancelada"].includes(r.status)&&(
                            <button className="btn btn-outline-danger btn-sm" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>handleAcao(r.id,"cancelar")}><i className="bi bi-x"/></button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {/* ── CALENDÁRIO ── */}
        {aba==="calendario"&&(
          <div style={{padding:16}}>
            <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:16,flexWrap:"wrap"}}>
              <select className="form-select" style={{width:"auto",fontSize:13}} value={calArea} onChange={e=>setCalArea(e.target.value)}>
                <option value="">Selecione a área</option>
                {areas.map(a=><option key={a.id} value={a.id}>{a.nmArea}</option>)}
              </select>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <button className="btn btn-outline-secondary btn-sm" onClick={prevMes}><i className="bi bi-chevron-left"/></button>
                <span style={{fontSize:14,fontWeight:700,color:"var(--gray-700)",minWidth:90,textAlign:"center"}}>{mesAno}</span>
                <button className="btn btn-outline-secondary btn-sm" onClick={nextMes}><i className="bi bi-chevron-right"/></button>
              </div>
              <button className="btn btn-outline-secondary btn-sm" onClick={carregarCalendario} disabled={calLoading}>
                {calLoading?<span className="spinner-border spinner-border-sm"/>:<i className="bi bi-arrow-clockwise"/>}
              </button>
              <div style={{display:"flex",gap:8,marginLeft:"auto",flexWrap:"wrap"}}>
                {[{background:"var(--bg-highlight)",color:"#1E40AF",label:"Confirmada"},{background:"var(--bg-success-soft)",color:"#166534",label:"Paga/Ativa"},{background:"var(--bg-danger-soft)",color:"#991B1B",label:"Bloqueio"},{background:"var(--bg-warning-soft)",color:"#854D0E",label:"Pendente"}].map(l=>(
                  <span key={l.label} style={{background:l.background,color:l.color,padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>{l.label}</span>
                ))}
              </div>
            </div>

            {/* Grade calendário */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:2}}>
              {["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"].map(d=>(
                <div key={d} style={{textAlign:"center",fontSize:12,fontWeight:700,color:"var(--gray-500)",padding:"6px 0"}}>{d}</div>
              ))}
              {cells.map((cell,i)=>(
                cell===null
                  ? <div key={i}/>
                  : <div key={i} style={{minHeight:80,border:"1px solid var(--gray-200)",borderRadius:6,padding:4,background:cell.bloqueios.length>0?"#FFF7ED":cell.reservas.length>0?"#F0FDF4":"#fff",cursor:"default"}}>
                      <div style={{fontSize:12,fontWeight:700,color:"var(--gray-600)",marginBottom:2}}>{cell.dia}</div>
                      {cell.bloqueios.map((b,j)=>(
                        <div key={j} style={{background:"var(--bg-danger-soft)",color:"#991B1B",borderRadius:4,padding:"1px 4px",fontSize:10,marginBottom:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                          <i className="bi bi-lock me-1"/>{b.motivo?.substring(0,15)}
                        </div>
                      ))}
                      {cell.reservas.map((r,j)=>(
                        <div key={j} style={{...STATUS_STYLE[r.status],borderRadius:4,padding:"1px 4px",fontSize:10,marginBottom:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                          {r.tpPeriodo==="Horario"?`${r.hrInicio?.substring(0,5)} `:""}{r.nmCondomino?.split(" ")[0]||r.status}
                        </div>
                      ))}
                    </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Modal caução */}
      {showCaucao&&(
        <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}}>
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Processar Caução</h5>
                <button className="btn-close btn-close-white" onClick={()=>setShowCaucao(false)}/>
              </div>
              <div className="modal-body">
                <p style={{fontSize:13,color:"var(--gray-600)",marginBottom:16}}>
                  Reserva: <strong>{caucaoTarget?.nmArea}</strong> — {fmtDt(caucaoTarget?.dtReserva)}<br/>
                  Valor da caução: <strong style={{color:"#854D0E"}}>{fmtMoeda(caucaoTarget?.vlrCaucao)}</strong>
                </p>
                <div className="d-flex gap-3 mb-3">
                  <button type="button" className={`btn flex-fill ${!caucaoForm.reter?"btn-success":"btn-outline-secondary"}`} onClick={()=>setCaucaoForm(p=>({...p,reter:false}))}>
                    <i className="bi bi-arrow-return-left me-1"/>Devolver Caução
                  </button>
                  <button type="button" className={`btn flex-fill ${caucaoForm.reter?"btn-danger":"btn-outline-secondary"}`} onClick={()=>setCaucaoForm(p=>({...p,reter:true}))}>
                    <i className="bi bi-exclamation-triangle me-1"/>Reter Caução
                  </button>
                </div>
                {!caucaoForm.reter&&(
                  <div><label className="form-label">Data da Devolução</label><input type="date" className="form-control" value={caucaoForm.dtDevolucao} onChange={e=>setCaucaoForm(p=>({...p,dtDevolucao:e.target.value}))}/></div>
                )}
                {caucaoForm.reter&&(
                  <div><label className="form-label">Motivo da Retenção <span className="required-mark">*</span></label><input className="form-control" value={caucaoForm.motivoRetencao} onChange={e=>setCaucaoForm(p=>({...p,motivoRetencao:e.target.value}))} placeholder="Descreva o motivo..."/></div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={()=>setShowCaucao(false)}>Cancelar</button>
                <button className={`btn ${caucaoForm.reter?"btn-danger":"btn-success"}`} onClick={handleDevolverCaucao}>
                  {caucaoForm.reter?"Reter e Converter em Receita":"Confirmar Devolução"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de cancelamento (motivo) */}
      {cancelTarget && (
        <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} onClick={()=>!cancelSaving && setCancelTarget(null)}>
          <div className="modal-dialog modal-md" onClick={e=>e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-x-octagon text-danger me-2"/>
                  Cancelar reserva
                </h5>
                <button className="btn-close" onClick={()=>setCancelTarget(null)} disabled={cancelSaving}/>
              </div>
              <div className="modal-body">
                <p style={{fontSize:13,color:"var(--gray-600)",marginBottom:12}}>
                  A reserva será cancelada e as cobranças em aberto serão estornadas.
                  Se faltarem poucos dias para a reserva, a taxa de cancelamento configurada na área será aplicada.
                </p>
                <label className="form-label fw-semibold">Motivo do cancelamento</label>
                <textarea className="form-control" rows={3} value={cancelMotivo}
                  onChange={e=>setCancelMotivo(e.target.value)}
                  placeholder="Descreva o motivo (opcional, mas recomendado para auditoria)"/>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={()=>setCancelTarget(null)} disabled={cancelSaving}>
                  Voltar
                </button>
                <button className="btn btn-danger" onClick={confirmarCancelamento} disabled={cancelSaving}>
                  {cancelSaving
                    ? <><span className="spinner-border spinner-border-sm me-2"/>Cancelando...</>
                    : <><i className="bi bi-x-octagon me-1"/>Cancelar reserva</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmação genérica (substitui window.confirm) */}
      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk || "Confirmar"}
          textoCancelar={confirmacao.textoCancelar || "Cancelar"}
          perigo={!!confirmacao.perigo}
          onConfirm={confirmacao.onConfirm}
          onCancel={()=>setConfirmacao(null)}
        />
      )}
    </div>
  );
}
